// removed by extract-text-webpack-plugin
module.exports = {"appContainer":"appContainer__appContainer--1CeSq","footer":"appContainer__footer--2uHHC","appBarContainer":"appContainer__appBarContainer--lwRnJ"};


//////////////////
// WEBPACK FOOTER
// ./src/client/plugins/app/styles/appContainer.scss
// module id = U155
// module chunks = 23